import React from 'react'
import {Icon} from '@chakra-ui/react'

const DiscountIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M14.6396 26.96C14.4296 26.96 14.2296 26.9 14.0496 26.77C13.7796 26.57 13.6396 26.27 13.6396 25.96C13.6396 25.75 13.6996 25.55 13.8296 25.37L23.2596 12.55C23.5896 12.11 24.2096 12.01 24.6596 12.34C24.9296 12.54 25.0696 12.84 25.0696 13.15C25.0696 13.36 25.0096 13.56 24.8796 13.74L15.4496 26.56C15.2496 26.83 14.9496 26.97 14.6396 26.97V26.96Z"
                fill="currentColor"
            />
            <path
                d="M14.35 17.7C12.5 17.7 11 16.2 11 14.35C11 12.5 12.5 11 14.35 11C16.2 11 17.7 12.5 17.7 14.35C17.7 16.2 16.2 17.7 14.35 17.7ZM14.35 12.99C13.6 12.99 13 13.6 13 14.34C13 15.08 13.61 15.69 14.35 15.69C15.09 15.69 15.7 15.08 15.7 14.34C15.7 13.6 15.09 12.99 14.35 12.99Z"
                fill="currentColor"
            />
            <path
                d="M24.7201 28.07C22.8701 28.07 21.3701 26.57 21.3701 24.72C21.3701 22.87 22.8701 21.37 24.7201 21.37C26.5701 21.37 28.0701 22.87 28.0701 24.72C28.0701 26.57 26.5701 28.07 24.7201 28.07ZM24.7201 23.36C23.9701 23.36 23.3701 23.97 23.3701 24.71C23.3701 25.45 23.9801 26.06 24.7201 26.06C25.4601 26.06 26.0701 25.45 26.0701 24.71C26.0701 23.97 25.4601 23.36 24.7201 23.36Z"
                fill="currentColor"
            />
            <path
                d="M20 39C9.52381 39 1 30.4762 1 20C1 9.52381 9.52381 1 20 1C30.4762 1 39 9.52381 39 20C39 30.4762 30.4762 39 20 39ZM20 2.42857C10.3143 2.42857 2.42857 10.3143 2.42857 20C2.42857 29.6857 10.3143 37.5714 20 37.5714C29.6857 37.5714 37.5714 29.6857 37.5714 20C37.5714 10.3143 29.6857 2.42857 20 2.42857Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DiscountIcon
